import type { FieldDefinition } from "./types";

/**
 * Round 8: the names of the target fields (`isTarget`, `shared/connectors/targetFields.ts`) whose
 * value in the form differs from the value the form was seeded with, in the definition's order.
 * The same "did the user change this" rule as the editor's re-validation (`changedFieldInputs`):
 * a stored credential is seeded as the mask, so an untouched one is not a change.
 */
export function changedTargetFieldNames(
  fieldDefinitions: readonly FieldDefinition[],
  values: Readonly<Record<string, unknown>>,
  baseline: Readonly<Record<string, unknown>>,
): string[] {
  return fieldDefinitions
    .filter((field) => field.isTarget === true && !field.isPlatformManaged)
    .filter((field) => JSON.stringify(values[field.id]) !== JSON.stringify(baseline[field.id]))
    .map((field) => field.name);
}

/** "Server Name", "Server Name and Port Number", "Server Name, Port Number and User Name". */
export function joinFieldNames(names: readonly string[]): string {
  if (names.length <= 1) return names[0] ?? "";
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
}
